import { useQuasar } from "quasar";
import { CURRENCY } from "src/assets/scripts/utilities/constants";
import PConfirmDialog from "src/components/PConfirmDialog.vue";
import PDialogForm from "src/components/PDialogForm.vue";
import { usePaymentsStore } from "src/stores/payments";

export function useApprove({ closeForm, formData }) {
  const $q = useQuasar();

  const loading = ref(false);

  const { approvePaymentRequest } = usePaymentsStore();

  const onConfirm = async (
    remarks,
    confirmDialog,
    doubleConfirmationDialog,
  ) => {
    try {
      loading.value = true;

      const payload = {
        _id: unref(formData)._id,
        reason: unref(remarks),
        source: unref(formData).source,
      };

      doubleConfirmationDialog?.hide();

      confirmDialog?.hide();

      await approvePaymentRequest(payload);

      closeForm();
    } catch (error) {
      console.error(error);
    } finally {
      loading.value = false;
    }
  };

  const doubleConfirmationHandler = (remarks, confirmDialog) => {
    try {
      const doubleConfirmationDialog = $q.dialog({
        component: PConfirmDialog,
        componentProps: {
          labelClass: "text-center q-ma-xl rounded-borders",
          label: "Final Approval confirmation ?",
          onConfirm: () =>
            onConfirm(remarks, confirmDialog, doubleConfirmationDialog),
        },
      });
    } catch (error) {
      console.error(error);
    }
  };

  const confirmApproval = () => {
    const confirmDialog = $q.dialog({
      component: PDialogForm,
      componentProps: {
        title: `Approve payment request ${unref(formData).internal_number}`,
        submitLabel: "Approve",
        cancellable: false,
        loading: loading,
        text: `Are you sure you want to approve this payment request of  ${
          CURRENCY.symbol
        } ${unref(formData).net_payable} to ${
          unref(formData)?.seller?.shop_name
        } ?`,
        textClass: "text-md text-neutral text-weight-bold",
        form: {
          input: {
            type: "textarea",
            autogrow: true,
            placeholder: "Enter Remarks",
            label: "Additional remarks",
            labelClasses: "text-sm text-neutral text-weight-bold",
            help: "Add any additional remarks here",
            helpClasses: "text-sm text-neutral-70 q-mt-none",
          },
        },
        onConfirm: (remarks) => {
          doubleConfirmationHandler(remarks, confirmDialog);
        },
      },
    });
  };

  const approveButton = computed(() => {
    return {
      loading: unref(loading),
      label: "Approve",
      type: "button",
      onClick: confirmApproval,
    };
  });

  return {
    approveButton,
  };
}
